module.exports = __webpack_public_path__ + "static/media/Cake Guy.f434c15d.jpg";